import { render } from "./CampaignCreate.vue?vue&type=template&id=4f1185e0"
import script from "./CampaignCreate.vue?vue&type=script&lang=js"
export * from "./CampaignCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__